// src/components/layout/TopBar.jsx
import React from "react";

function TopBar() {
  return (
    <div className="topbar topbar-fixed py-1 text-white small">
      <div className="container d-flex justify-content-between align-items-center">
        {/* Bloc gauche : message + numéros */}
        <div className="d-flex flex-wrap align-items-center gap-2">
          <span className="text-uppercase fw-semibold">
            Commandez vos équipements :
          </span>
          <span>
            📞{" "}
            <a
              href="tel:+22893362525"
              className="text-white text-decoration-none"
            >
              (+228)
            </a>{" "}
            <a
              href="tel:+22893362525"
              className="text-white text-decoration-none"
            >
              93 36 25 25
            </a>
          </span>
        </div>

        {/* Bloc droite : newsletter + WhatsApp */}
        <div className="d-flex flex-wrap align-items-center gap-3">
          <span className="d-none d-sm-inline">
            📩 Inscrivez-vous à notre newsletter
          </span>
          <a
            href="https://wa.me/22893362525?text=Bonjour,%20je%20souhaite%20des%20informations%20sur%20vos%20imprimantes%20et%20TPE."
            target="_blank"
            rel="noreferrer"
            className="btn btn-sm btn-outline-light py-0 px-2"
          >
            💬 WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}

export default TopBar;
